import {Dropdown} from './dropdown';

const REVOCABLE_OPTIONS_FR: Dropdown<boolean>[] = [
  {name: 'Révocable', value: true},
  {name: 'Irrévocable', value: false},
];

const REVOCABLE_OPTIONS_EN: Dropdown<boolean>[] = [
  {name: 'Revocable', value: true},
  {name: 'Irrevocable', value: false},
];

export const REVOCABLE_OPTIONS = {
  en: REVOCABLE_OPTIONS_EN,
  fr: REVOCABLE_OPTIONS_FR,
};
